import { AxiosError } from 'axios'

import { ITestimonialVideoAddress, MODALITY_LABELS } from '../../../services/TestimonialVideo/types'

// TestimonialVideoSubmissionCreateRequest: `video => mimetypes:video/mp4|mimes:mp4|max:102400`.
export const MAX_VIDEO_SIZE_MB = 100

export const MODALITY_OPTIONS = Object.entries(MODALITY_LABELS).map(([value, label]) => ({ value, label }))

export const ZIP_CODE_REGEX = /^\d{5}-\d{3}$/

// Same list as the API (TestimonialVideoSubmission::STATES).
export const BRAZILIAN_STATES =
  'AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO'.split(' ')

export const EMPTY_ADDRESS: ITestimonialVideoAddress = {
  zip_code: '',
  street: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: ''
}

/** Client-side checks shared by the public form and the edit modal, keyed like the API errors. */
export const validateAddress = (address: ITestimonialVideoAddress): Record<string, string[]> => {
  const errors: Record<string, string[]> = {}

  if (!ZIP_CODE_REGEX.test(address.zip_code)) errors.zip_code = ['O CEP deve estar no formato 00000-000.']
  if (!address.street.trim()) errors.street = ['O logradouro é obrigatório.']
  if (!address.number.trim()) errors.number = ['O número é obrigatório.']
  if (!address.neighborhood.trim()) errors.neighborhood = ['O bairro é obrigatório.']
  if (!address.city.trim()) errors.city = ['A cidade é obrigatória.']
  if (!BRAZILIAN_STATES.includes(address.state.trim().toUpperCase())) errors.state = ['Informe uma UF válida.']

  return errors
}

/** One-line address, e.g. "Avenida Paulista, 1000 - Apto 12 - Bela Vista, São Paulo/SP - CEP 01310-100". */
export const formatAddress = (address: Omit<ITestimonialVideoAddress, 'complement'> & { complement: string | null }) =>
  [
    `${address.street}, ${address.number}`,
    address.complement,
    `${address.neighborhood}, ${address.city}/${address.state}`,
    `CEP ${address.zip_code}`
  ]
    .filter(Boolean)
    .join(' - ')

export const trimAddress = (address: ITestimonialVideoAddress): ITestimonialVideoAddress => ({
  zip_code: address.zip_code,
  street: address.street.trim(),
  number: address.number.trim(),
  complement: address.complement.trim(),
  neighborhood: address.neighborhood.trim(),
  city: address.city.trim(),
  state: address.state.trim().toUpperCase()
})

/** Field errors of a validation response (the API answers 400; 422 is a fallback), or null. */
export const validationErrorsOf = (err: unknown): Record<string, string[]> | null => {
  const response = (err as AxiosError<{ errors?: Record<string, string[]> }>)?.response
  const status = response?.status

  return (status === 400 || status === 422) && response?.data?.errors ? response.data.errors : null
}
